import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsGraphicTabletDraw: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 5.335H32v21.33h-1.52ZM1.52 26.665h28.96v1.53H1.52Zm27.43-22.86h-3.04v1.53h-1.53v1.52h-1.52v1.53h-1.53v1.52h-1.52v1.52h-1.52v1.53h-1.53v1.52h-1.52v3.05h3.05v-1.53h1.52v-1.52h1.52v-1.52h1.53v-1.53h1.52v-1.52h1.53v-1.52h1.52v-1.53h1.52zm-15.24 13.72h1.53v1.52h-1.53Zm-1.52-6.1h1.52v1.53h-1.52Zm-3.05 7.62h4.57v1.53H9.14Zm1.53-6.09h1.52v1.52h-1.52Zm-1.53-3.05h3.05v1.52H9.14Zm0 4.57h1.53v1.52H9.14Zm-1.52 1.52h1.52v3.05H7.62Zm0-4.57h1.52v1.53H7.62Zm-1.52 1.53h1.52v1.52H6.1Z\"/><path fill=\"currentColor\" d=\"M4.57 8.385h15.24v-1.53H3.05v18.29h25.9V9.905h-1.52v13.71H4.57zm-3.05-4.58h21.34v1.53H1.52ZM0 5.335h1.52v21.33H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsGraphicTabletDraw
